import { render, staticRenderFns } from "./ContractFieldsForm.vue?vue&type=template&id=773fff42&"
import script from "./ContractFieldsForm.vue?vue&type=script&lang=js&"
export * from "./ContractFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports